// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"462":"legal","508":"dev","678":"wizard"}[chunkId] + "." + {"462":"025dfad5","508":"806b3d8f","678":"47b1eb3b"}[chunkId] + ".js";
};